<template>
  <div class="full-wrapper">
    <el-scrollbar class="bar-visible">
      <div class="full">
        <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
          <el-tab-pane label="작업 정보" name="WTaskLogTable">
            <el-row class="title-bar" type="flex" justify="end">
              <el-date-picker class="mr-r4" size="small" style="width: 220px;" :editable="false" type="daterange" v-model="taskDateRange" :range-separator="defaultDateRangeOptions.rangeSeparator"
                :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions"
                :defaultTime="defaultDateRangeOptions.defaultTime" format="yyyy-MM-dd" :clearable="false">
              </el-date-picker>
              <el-button class="mr-r4" size="small" @click="onClickConfirmButton" :disabled="checkedRows.length === 0">확인</el-button>
              <w-header-search-button @click="showTaskSearchTool = !showTaskSearchTool"></w-header-search-button>
            </el-row>
            <w-task-log-table ref="WTaskLogTable" :active="taskActive" :time-param="timeParam" :show-search-tool="showTaskSearchTool" :checked-rows="checkedRows" @selection-change="onSelectionChange" />
          </el-tab-pane>
          <el-tab-pane label="이벤트 정보" name="WEventLogTable">
            <el-row class="title-bar" type="flex" justify="end">
              <el-date-picker class="mr-r4" size="small" style="width: 220px;" :editable="false" type="daterange" v-model="eventDateRange" :range-separator="defaultDateRangeOptions.rangeSeparator"
                :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions"
                :defaultTime="defaultDateRangeOptions.defaultTime" format="yyyy-MM-dd" :clearable="false">
              </el-date-picker>
              <el-button class="mr-r4" size="small" @click="onClickConfirmButton" :disabled="checkedRows.length === 0">확인</el-button>
              <w-header-search-button @click="showEventSearchTool = !showEventSearchTool"></w-header-search-button>
            </el-row>
            <w-event-log-table ref="WEventLogTable" :active="eventActive" :time-param="timeParam" :show-search-tool="showEventSearchTool" :checked-rows="checkedRows" @selection-change="onSelectionChange" />
          </el-tab-pane>
        </w-tool-tabs>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import moment from 'moment';
import { defaultDateRangeOptions } from '@/utils/date';
import LogAPI from '@/api/log/common';
import msgUtils from '@/utils/message';
import WTaskLogTable from '@/views/virtual/performance/group/components/TaskLogTable';
import WEventLogTable from '@/views/virtual/performance/group/components/EventLogTable';

const endDatetime = moment();
const startDatetime = moment(endDatetime).subtract(7, 'days');

export default {
  name: 'WHypervLogGroup',
  components: {
    WTaskLogTable,
    WEventLogTable,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WTaskLogTable',
      showTaskSearchTool: false,
      showEventSearchTool: false,
      showAlarmSearchTool: false,
      defaultDateRangeOptions,
      taskDateRange: [startDatetime.toDate(), endDatetime.toDate()],
      eventDateRange: [startDatetime.toDate(), endDatetime.toDate()],
      alarmDateRange: [startDatetime.toDate(), endDatetime.toDate()],
      checkedRows: [],
    };
  },
  computed: {
    taskActive() {
      return this.active && this.activeTab === WTaskLogTable.name;
    },
    eventActive() {
      return this.active && this.activeTab === WEventLogTable.name;
    },
    timeParam() {
      let timeParam = {};
      if (this.activeTab === WTaskLogTable.name) {
        timeParam = {
          startDatetime: this.taskDateRange[0].getTime(),
          endDatetime: this.taskDateRange[1].getTime(),
        };
      } else if (this.activeTab === WEventLogTable.name) {
        timeParam = {
          startDatetime: this.eventDateRange[0].getTime(),
          endDatetime: this.eventDateRange[1].getTime(),
        };
      }
      return timeParam;
    },
  },
  watch: {
    activeTab() {
      this.checkedRows = [];
    },
    timeParam: {
      handler() {
        const logTable = this.$refs[this.activeTab];
        this.$nextTick(() => {
          logTable.loadStore();
        });
      },
    },
  },
  methods: {
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    onClickConfirmButton() {
      const params = this.checkedRows;
      LogAPI.updateLogIsChecked(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.CHECK, '로그', response.data.success));
          setTimeout(() => {
            this.$refs[this.activeTab].loadStore();
          }, 1500);
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.CHECK, '로그', response.data.success));
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/hypervlog/index.vue